// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-28
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { IconRemove, IconRemoveAudi } from 'src/content/icons';
import { strings } from 'src/localization/index';
import { Diagnoses } from '../WriteYourOwn';
import { EventOrElement } from 'src/types';
import { THEME } from 'src/constants/ThemeNames';
import css from './AddedIssues.module.scss';

const THEME_HEADER_CLASSES: Record<string, string | undefined> = {
    mazda: css.headerMazda,
    genesis: css.headerGenesis,
};

interface IProps {
    // The list of diagnosed and custom issues
    issueList: Diagnoses[]
    // Removes an issue from the list
    removeIssue: (id: string, e: EventOrElement) => void
    theme: 'mazda' | 'genesis' | string
}

/** Renders the list of user-added diagnostic issues with a delete action for each. */
const AddedIssues = (props: IProps) => {
    const { issueList, removeIssue, theme } = props;

    const headerClass = THEME_HEADER_CLASSES[theme];
    const isAudi = theme === THEME.AUDI;
    // Alpha uses a bare X rather than the circled icon the other themes use. Named for the
    // action here - this is the per-issue delete affordance, not a dialog close button.
    const RemoveIcon = isAudi ? IconRemoveAudi : IconRemove;

    // Computed outside the map so each class list is built once per render rather than per issue.
    const issueClass = classNames(css.issue, { [css.issueAudi]: isAudi });
    const iconClass = classNames(css.icon, { [css.iconAudi]: isAudi });

    const issues = useMemo(() => issueList.map((issue, index) => (
        <div key={issue.id} className={issueClass}>
            <p className={css.issueText}>{issue.diagnosis}</p>
            <RemoveIcon id={'deleteBtn' + index} aria-label={'Remove issue ' + (index + 1)}
                onClick={(e: React.MouseEvent<SVGSVGElement>) => removeIssue(issue.id, e)}
                className={iconClass}/>
        </div>
    )), [issueList, removeIssue, issueClass, iconClass, RemoveIcon]);

    return (
        <div id='addedIssues'>
            <h2 className={headerClass}>{strings.AddedIssue}</h2>
            {issues}
        </div>
    );
};

export default AddedIssues;